import { render, staticRenderFns } from "./productsDatabase.vue?vue&type=template&id=13c1f29d&"
import script from "./productsDatabase.vue?vue&type=script&lang=js&"
export * from "./productsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports